import { findLast } from 'lodash';

import {
  DOCUMENTS_SIDES,
  TENANT_DOCS_DESCRIPTIONS,
} from '../../../../shared/constants';
import { IGuarantorDocument } from '../../../../shared/ts/document';

const RequiredFieldForSelfEmployed: {
  label: string;
  sideLabel?: string;
  type: string;
  description?: string;
  documentSide?: string;
}[] = [
  {
    label: 'common:idCardOrPassport',
    sideLabel: 'common:front',
    type: 'identity_document',
    documentSide: DOCUMENTS_SIDES.FRONT,
  },
  {
    label: 'common:idCardOrPassport',
    sideLabel: 'common:rear',
    type: 'identity_document',
    documentSide: DOCUMENTS_SIDES.REAR,
  },
  { label: 'form:fiscalCode', type: 'tax_number' },
  {
    label: 'form:lastIncomeTaxReturn',
    type: 'proof_of_income',
    description: TENANT_DOCS_DESCRIPTIONS.LAST_INCOME_TAX_RETURN,
  },
  {
    label: 'form:secondLastIncomeTaxReturn',
    type: 'proof_of_income',
    description: TENANT_DOCS_DESCRIPTIONS.SECOND_LAST_INCOME_TAX_RETURN,
  },
  {
    label: 'form:latestAccountStatement',
    type: 'proof_of_income',
    description: TENANT_DOCS_DESCRIPTIONS.BANK_ACCOUNT_BALANCE,
  },
  {
    label: 'form:penultimateAccountStatement',
    type: 'proof_of_income',
    description: TENANT_DOCS_DESCRIPTIONS.PENULTIMATE_ACCOUNT_STATEMENT,
  },
  {
    label: 'form:prepenultimateAccountStatement',
    type: 'proof_of_income',
    description: TENANT_DOCS_DESCRIPTIONS.PREPENULTIMATE_ACCOUNT_STATEMENT,
  },
];

const RequiredFieldForEmploye: {
  label: string;
  sideLabel?: string;
  type: string;
  description?: string;
  documentSide?: string;
}[] = [
  {
    label: 'common:idCardOrPassport',
    sideLabel: 'common:front',
    type: 'identity_document',
    documentSide: DOCUMENTS_SIDES.FRONT,
  },
  {
    label: 'common:idCardOrPassport',
    sideLabel: 'common:rear',
    type: 'identity_document',
    documentSide: DOCUMENTS_SIDES.REAR,
  },
  { label: 'form:fiscalCode', type: 'tax_number' },
  {
    label: 'form:workContract',
    type: 'proof_of_income',
    description: TENANT_DOCS_DESCRIPTIONS.WORK_CONTRACT,
  },
  {
    label: 'form:lastPaycheck',
    type: 'proof_of_income',
    description: TENANT_DOCS_DESCRIPTIONS.LAST_PAYCHECK,
  },
  {
    label: 'form:secondLastPaycheck',
    type: 'proof_of_income',
    description: TENANT_DOCS_DESCRIPTIONS.SECOND_LAST_PAYCHECK,
  },
  {
    label: 'form:thirdLastPaycheck',
    type: 'proof_of_income',
    description: TENANT_DOCS_DESCRIPTIONS.THIRD_LAST_PAYCHECK,
  },
];

const RequiredFieldForPensioner: {
  label: string;
  sideLabel?: string;
  type: string;
  description?: string;
  documentSide?: string;
}[] = [
  {
    label: 'common:idCardOrPassport',
    sideLabel: 'common:front',
    type: 'identity_document',
    documentSide: DOCUMENTS_SIDES.FRONT,
  },
  {
    label: 'common:idCardOrPassport',
    sideLabel: 'common:rear',
    type: 'identity_document',
    documentSide: DOCUMENTS_SIDES.REAR,
  },
  { label: 'form:fiscalCode', type: 'tax_number' },
  {
    label: 'form:lastPensionSlip',
    type: 'proof_of_income',
    description: TENANT_DOCS_DESCRIPTIONS.LAST_PENSION_SLIPS,
  },
  {
    label: 'form:penultimatePensionSlip',
    type: 'proof_of_income',
    description: TENANT_DOCS_DESCRIPTIONS.SECOND_LAST_PENSION_SLIPS,
  },
];

// const RequiredField: {
//   label: string;
//   sideLabel?: string;
//   type: string;
//   description?: string;
//   documentSide?: string;
// }[] = [
//   {
//     label: 'common:idCardOrPassport',
//     sideLabel: 'common:front',
//     type: 'identity_document',
//     documentSide: DOCUMENTS_SIDES.FRONT,
//   },
//   {
//     label: 'common:idCardOrPassport',
//     sideLabel: 'common:rear',
//     type: 'identity_document',
//     documentSide: DOCUMENTS_SIDES.REAR,
//   },
//   { label: 'form:fiscalCode', type: 'tax_number' },
// ];

const guestOccupation: Record<
  string,
  {
    label: string;
    sideLabel?: string;
    type: string;
    description?: string;
    documentSide?: string;
  }[]
> = {
  pensioner: RequiredFieldForPensioner,
  selfEmployed: RequiredFieldForSelfEmployed,
  employee: RequiredFieldForEmploye,
};

export const filterRequiredMissingDocumentForGuarantor = ({
  index,
  occupation,
  guarantorDocuments,
}: {
  index: number;
  occupation: string;
  guarantorDocuments?: IGuarantorDocument[];
}) => {
  const requiredFields = guestOccupation[occupation] || [];

  const missingFields = requiredFields
    .filter(field => {
      const document = findLast(guarantorDocuments, {
        ...(field.description && { description: field.description }),
        type: field.type,
      });

      if (!document) {
        return true;
      }

      if (field.documentSide) {
        const sideField =
          field.documentSide === DOCUMENTS_SIDES.FRONT
            ? document.document_front || document.front
            : document.document_rear || document.rear;

        return !sideField;
      }

      return false;
    })
    .map(field => ({ label: field.label, sideLabel: field.sideLabel }));

  return {
    label:
      index === 0
        ? 'common:guarantorDocuments'
        : 'common:otherGuarantorDocuments',
    fields: missingFields,
  };
};
